<template>
    <b-card>
        <b-card-header>Bokning till transportör</b-card-header>
        <b-card-body>
            <!-- <b-row>
                <b-col></b-col>
                <b-col v-for="x in colTitles" :key="x">{{ x }}</b-col>
            </b-row>
            <b-row v-for="(r,ri) in rowTitles" :key="r">
                <b-col>{{ r }}</b-col>
                <b-col v-for="(x,ci) in colTitles" :key="x">{{ cells[ri][ci] }}<b-badge v-if="GetDiff(ri,ci)" v-bind:style="GetDiffStyle(GetDiff(ri,ci))">({{ GetDiff(ri,ci) }}%)</b-badge></b-col>
            </b-row> -->
            <b-row>
                <b-col>
                <table class="qv-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th v-for="x in colTitles" :key="x"><p style="white-space: nowrap;transform: rotate(-0deg)">{{ x }}</p></th>
                        </tr>                        
                    </thead>
                    <tbody>
                        <tr v-for="(r,ri) in rowTitles" :key="r">
                            <td>{{ r }}</td>
                            <td v-for="(x,ci) in colTitles" :key="x">{{ cells[ri][ci] }}<b-badge v-if="GetDiff(ri,ci)" v-bind:style="GetDiffStyle(GetDiff(ri,ci))">({{ GetDiff(ri,ci) }}%)</b-badge></td>
                        </tr>
                    </tbody>
                </table>

                </b-col>            
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();

//TODO: Make this generic pivot...

export default {
    name: 'bookingtrenddash',
    props: { refresher: Number, titleField: String, rowField: String, cellField: String, date:String},
    data() {
        return {
            work: [],
            colTitles: [],            
            rowTitles: [],
            cells: []
        }
    },
    created() {
        this.RefreshStats();
    },
    watch: {
        refresher: function () { this.RefreshStats() },
        date: function () { this.RefreshStats() },
    },
    methods: {
        RefreshStats() {
            api.get('/api/Dash/GetBookingTrend?serviceTypeId=-1&dateFilter='+this.date).then(res => {
                this.work = res.data;

                this.colTitles = [...new Set(res.data.map(x => x[this.titleField]))].sort((a,b)=> a < b ? -1 : 1);
                this.rowTitles = [...new Set(res.data.map(x => x[this.rowField]))].sort((a,b)=> a < b ? -1 : 1);
                
                this.cells = [];
                for(var r=0; r < this.rowTitles.length; r++) {
                    let rowcontent = [];
                    for(var c=0; c < this.colTitles.length; c++)
                        rowcontent.push(this.GetCellValue(this.rowTitles[r], this.colTitles[c]));
                    this.cells.push(rowcontent);         
                }                    
            });
        },
        GetCellValue(row,col) {
            var res = 0;
            this.work.filter(x => x[this.titleField] == col && x[this.rowField]==row)
                .map(x => res +=x[this.cellField]);

            return res;
        },
        GetDiff(ri,ci) {
            if(ci>0) {
                let v = this.cells[ri][ci];
                let ov = this.cells[ri][ci-1];
                                
                if(ov) {
                    let dv = 100.0*(v-ov)/ov;
                    dv = Math.round(dv);
                    //return `(${dv}%)`
                    return dv;
                }
                    
            }

            return 0;
        },
        GetDiffStyle(v) {

            // let r = v < 0 ? -v*2+50 : 0;
            // let g = 255;
            // let b = (v > 0 ? v : 0) +50;

            // let res = { 'background-color': `rgb(${r},${g},${b})`};
            var cl = 'gray';
            if(v < -50) cl = 'red';
            else if(v < -20) cl='orange';            

            let res = { 'background-color': cl }

            return res;
        }        
    }
}
</script>

